import type {
  ApplicationsQueryVariables,
  ApplicationsQuery,
} from './fetchApplications.hirer.graphql.generated.ts';

import hirerGraphClient from './hirer/client';
import gql from 'graphql-tag';
import { findAuthenticationError } from './utils.ts';
import { application } from './application.hirer.graphql.ts';

const query = gql`
  query Applications(
    $input: ApplicationsInput!
    $nationalitiesInput2: ApplicationProfileNationalitiesInput!
    $displayLabelInput2: CandidateProfileRightToWorkDisplayLabelInput!
    $countryNameInput2: CandidateProfileNationalityCountryNameInput!
    $displayDescriptionInput2: LocationDisplayDescriptionInput!
  ) {
    applications(input: $input) {
      ... on ApplicationsResponseSuccess {
        result {
          ...application
        }
        pageInfo {
          pageNumber
          pageSize
          preFilterTotal
          total
          totalPages
        }
        filterCounts {
          questionnaireFilterCounts {
            id
            count
          }
        }
        statusFolderCounts {
          newCount
          viewedCount
          inboxCount
          prescreenCount
          shortlistCount
          interviewCount
          offerCount
          acceptCount
          notSuitableCount
          totalCount
        }
      }
      ... on ResponseError {
        error
      }
    }
  }
  ${application}
`;

export const fetchApplications = async (
  variables: ApplicationsQueryVariables,
) => {
  const result = await hirerGraphClient.query<
    ApplicationsQuery,
    ApplicationsQueryVariables
  >({
    variables,
    query,
  });

  if (result.data === null && result.errors && result.errors.length > 0) {
    if (findAuthenticationError(result.errors)) {
      throw new Error('UNAUTHENTICATED');
    }
    throw new Error('Error fetching applications');
  }

  if (result.data.applications.__typename === 'ResponseError') {
    throw new Error('Error fetching applications');
  }

  return result.data.applications;
};
